import React from 'react';

const House = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    className={className}
    {...props}
    viewBox="0 0 480 193"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M94.5291 158.989H56.252V192.317H94.5291V158.989Z" fill="#E2ACAC" />
    <mask
      id="mask0_9144_6854"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="141"
      y="59"
      width="55"
      height="95"
    >
      <path d="M195.1 59.4031H141.514V153.179H195.1V59.4031Z" fill="white" />
    </mask>
    <g mask="url(#mask0_9144_6854)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.29 102.859C192.422 98.9138 194.379 94.1653 194.936 89.1583C195.492 84.1514 194.626 79.089 192.436 74.5521C190.247 70.0151 186.822 66.1874 182.556 63.5082C178.29 60.829 173.355 59.4069 168.317 59.405C163.279 59.4032 158.343 60.8216 154.075 63.4976C149.806 66.1736 146.379 69.9988 144.186 74.5341C141.993 79.0694 141.123 84.1312 141.676 89.1385C142.228 94.1459 144.182 98.8959 147.311 102.843C148.09 103.82 148.515 105.032 148.517 106.281C148.52 107.53 148.099 108.744 147.324 109.723C144.191 113.669 142.234 118.417 141.678 123.424C141.121 128.431 141.987 133.493 144.177 138.03C146.367 142.567 149.791 146.395 154.058 149.074C158.324 151.753 163.259 153.175 168.297 153.177C173.335 153.179 178.271 151.761 182.539 149.085C186.807 146.409 190.235 142.584 192.428 138.048C194.621 133.513 195.491 128.451 194.938 123.444C194.385 118.437 192.432 113.687 189.302 109.739C188.524 108.762 188.099 107.55 188.096 106.301C188.094 105.052 188.515 103.839 189.29 102.859Z"
        fill="url(#paint0_linear_9144_6854)"
      />
    </g>
    <path
      d="M268.725 0L252.305 16.6134V107.177H283.132V16.6134L268.725 0Z"
      fill="#696969"
    />
    <path d="M252.304 16.6133H206.9V107.177H252.304V16.6133Z" fill="black" />
    <path d="M327.627 81.3898H262.621V192.317H327.627V81.3898Z" fill="black" />
    <path
      d="M280.288 169.793H233.186V192.318H280.288V169.793Z"
      fill="#696969"
    />
    <path d="M180.817 158.989H155.797V192.317H180.817V158.989Z" fill="black" />
    <path d="M480 154.005H400.787V192.318H480V154.005Z" fill="#696969" />
    <path d="M217.24 107.178H187.156V192.317H217.24V107.178Z" fill="#2C2C2C" />
    <path
      d="M480 154.004L400.808 154.514L373.289 123.639H454.326L480 154.004Z"
      fill="#96FF96"
    />
    <path
      d="M280.288 169.792H233.186L217.24 153.179H266.806L280.288 169.792Z"
      fill="#96FF96"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154.346 131.818C156.721 128.827 158.205 125.227 158.627 121.431C159.049 117.634 158.392 113.796 156.732 110.356C155.072 106.917 152.475 104.014 149.241 101.983C146.006 99.9518 142.264 98.8736 138.445 98.8722C134.625 98.8708 130.883 99.9462 127.646 101.975C124.41 104.004 121.812 106.904 120.149 110.343C118.486 113.781 117.827 117.619 118.246 121.416C118.665 125.212 120.146 128.813 122.519 131.807C123.109 132.547 123.431 133.466 123.433 134.413C123.435 135.36 123.116 136.28 122.528 137.023C120.153 140.014 118.669 143.614 118.247 147.41C117.825 151.206 118.482 155.045 120.142 158.485C121.803 161.924 124.399 164.826 127.634 166.858C130.868 168.889 134.61 169.967 138.43 169.969C142.249 169.97 145.992 168.895 149.228 166.866C152.464 164.837 155.062 161.937 156.725 158.498C158.388 155.06 159.048 151.222 158.628 147.425C158.209 143.629 156.728 140.028 154.355 137.034C153.765 136.294 153.443 135.375 153.441 134.428C153.44 133.481 153.758 132.561 154.346 131.818Z"
      fill="#00B300"
    />
    <path
      d="M169.502 99.6416V141.232"
      stroke="black"
      strokeWidth="2.28553"
      strokeMiterlimit="10"
    />
    <path
      d="M176.405 110.731L169.502 117.082"
      stroke="black"
      strokeWidth="2.28553"
      strokeMiterlimit="10"
    />
    <path
      d="M266.805 107.177H217.106L201.16 90.5636H253.484L266.805 107.177Z"
      fill="#96FF96"
    />
    <path
      d="M374.895 40.5157C384.672 40.5157 392.598 32.5897 392.598 22.8124C392.598 13.0352 384.672 5.10913 374.895 5.10913C365.117 5.10913 357.191 13.0352 357.191 22.8124C357.191 32.5897 365.117 40.5157 374.895 40.5157Z"
      fill="#96FF96"
    />
    <path
      d="M78.4551 132.875L118.123 132.874L137.463 116.261H96.9876L78.4551 132.875Z"
      fill="#96FF96"
    />
    <path d="M118.122 132.875H78.4531V192.317H118.122V132.875Z" fill="black" />
    <path
      d="M206.9 16.6134H252.305L268.725 0H222.692L206.9 16.6134Z"
      fill="#96FF96"
    />
    <path
      d="M94.5291 158.268H56.2521L45.8867 141.654H86.3619L94.5291 158.268Z"
      fill="#96FF96"
    />
    <path
      d="M155.797 158.989H180.817L213.13 132.875H155.797V158.989Z"
      fill="#96FF96"
    />
    <path
      d="M187.156 107.177H217.105L201.16 90.5636L187.156 107.177Z"
      fill="#2C2C2C"
    />
    <path d="M45.8871 141.654L36.418 158.27H56.2524" fill="#2C2C2C" />
    <path
      d="M408.714 56.4209H373.289V123.639H408.714V56.4209Z"
      fill="#696969"
    />
    <path
      d="M408.714 47.9061H373.289V56.4213H408.714V47.9061Z"
      fill="#96FF96"
    />
    <path
      d="M373.289 47.9061H341.094V56.4213H373.289V47.9061Z"
      fill="#C9FFC9"
    />
    <path d="M327.627 72.875H262.621V81.3902H327.627V72.875Z" fill="#C9FFC9" />
    <path
      d="M400.788 22.8125H374.775V47.9062H400.788V22.8125Z"
      fill="#696969"
    />
    <path d="M374.776 22.8125H348.764V47.9062H374.776V22.8125Z" fill="black" />
    <path d="M266.805 107.178H217.24V153.179H266.805V107.178Z" fill="#696969" />
    <path
      d="M118.123 132.874L155.797 132.875L137.463 116.261L118.123 132.874Z"
      fill="#696969"
    />
    <path
      d="M155.796 132.875H118.123V192.317H155.796V132.875Z"
      fill="#696969"
    />
    <path d="M56.2523 158.268H36.418V192.317H56.2523V158.268Z" fill="#2C2C2C" />
    <path d="M94.6187 158.268H56.252V192.317H94.6187V158.268Z" fill="#696969" />
    <path
      d="M233.186 192.317H217.24V153.179L233.186 169.792V192.317Z"
      fill="#2C2C2C"
    />
    <path
      d="M213.129 192.317H180.816V158.989L213.129 132.875V192.317Z"
      fill="#696969"
    />
    <path
      d="M341.094 56.4209V192.317H373.288V123.638V56.4209H341.094Z"
      fill="black"
    />
    <path
      d="M373.289 123.639V192.317H400.788V154.22L373.289 123.639Z"
      fill="black"
    />
    <path d="M280.581 88.7793H271.514V100.03H280.581V88.7793Z" fill="#696969" />
    <path d="M274.735 88.7793H271.514V100.03H274.735V88.7793Z" fill="#E6FFE6" />
    <path d="M299.069 88.7793H290.002V100.03H299.069V88.7793Z" fill="#696969" />
    <path d="M293.224 88.7793H290.002V100.03H293.224V88.7793Z" fill="#E6FFE6" />
    <path d="M317.882 88.7793H308.814V100.03H317.882V88.7793Z" fill="#696969" />
    <path d="M312.036 88.7793H308.814V100.03H312.036V88.7793Z" fill="#E6FFE6" />
    <path
      d="M280.581 116.345H271.514V127.595H280.581V116.345Z"
      fill="#696969"
    />
    <path
      d="M274.735 116.345H271.514V127.595H274.735V116.345Z"
      fill="#E6FFE6"
    />
    <path
      d="M299.069 116.345H290.002V127.595H299.069V116.345Z"
      fill="#696969"
    />
    <path
      d="M293.224 116.345H290.002V127.595H293.224V116.345Z"
      fill="#E6FFE6"
    />
    <path
      d="M317.882 116.345H308.814V127.595H317.882V116.345Z"
      fill="#696969"
    />
    <path
      d="M312.036 116.345H308.814V127.595H312.036V116.345Z"
      fill="#E6FFE6"
    />
    <path
      d="M280.581 145.101H271.514V156.352H280.581V145.101Z"
      fill="#696969"
    />
    <path
      d="M274.735 145.101H271.514V156.352H274.735V145.101Z"
      fill="#E6FFE6"
    />
    <path
      d="M299.069 145.101H290.002V156.352H299.069V145.101Z"
      fill="#696969"
    />
    <path
      d="M293.224 145.101H290.002V156.352H293.224V145.101Z"
      fill="#E6FFE6"
    />
    <path
      d="M317.882 145.101H308.814V156.352H317.882V145.101Z"
      fill="#696969"
    />
    <path
      d="M312.036 145.101H308.814V156.352H312.036V145.101Z"
      fill="#E6FFE6"
    />
    <path
      d="M299.069 173.375H290.002V184.625H299.069V173.375Z"
      fill="#696969"
    />
    <path
      d="M293.224 173.375H290.002V184.625H293.224V173.375Z"
      fill="#E6FFE6"
    />
    <path
      d="M317.882 173.375H308.814V184.625H317.882V173.375Z"
      fill="#696969"
    />
    <path
      d="M312.036 173.375H308.814V184.625H312.036V173.375Z"
      fill="#E6FFE6"
    />
    <mask
      id="mask1_9144_6854"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="139"
      width="30"
      height="52"
    >
      <path
        d="M29.9648 139.937H0.986328V190.649H29.9648V139.937Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_9144_6854)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.8227 163.437C28.5168 161.304 29.5751 158.736 29.8761 156.028C30.1771 153.321 29.7086 150.583 28.5244 148.129C27.3403 145.676 25.4884 143.606 23.1813 142.157C20.8741 140.708 18.2053 139.939 15.481 139.938C12.7566 139.937 10.0872 140.704 7.77902 142.151C5.47083 143.599 3.61739 145.667 2.43139 148.12C1.24539 150.572 0.774881 153.31 1.07386 156.018C1.37284 158.725 2.42919 161.294 4.1217 163.429C4.54271 163.957 4.77252 164.612 4.77373 165.288C4.77494 165.964 4.54748 166.62 4.12836 167.149C2.43428 169.283 1.37603 171.851 1.07504 174.559C0.774049 177.266 1.24252 180.004 2.42669 182.457C3.61087 184.911 5.46276 186.981 7.76987 188.43C10.077 189.878 12.7458 190.648 15.4701 190.649C18.1945 190.65 20.8639 189.882 23.1721 188.435C25.4802 186.988 27.3337 184.92 28.5197 182.467C29.7057 180.014 30.1762 177.277 29.8772 174.569C29.5782 171.861 28.5219 169.293 26.8294 167.158C26.4084 166.63 26.1786 165.974 26.1774 165.299C26.1762 164.623 26.4036 163.967 26.8227 163.437Z"
        fill="url(#paint1_linear_9144_6854)"
      />
    </g>
    <path
      d="M15.4766 150.759V192.349"
      stroke="black"
      strokeWidth="2.28553"
      strokeMiterlimit="10"
    />
    <path
      d="M8.57227 161.848L15.4753 168.198"
      stroke="black"
      strokeWidth="2.28553"
      strokeMiterlimit="10"
    />
    <path
      d="M137.135 131.891C138.369 131.891 139.552 132.381 140.424 133.253C141.296 134.125 141.786 135.308 141.786 136.541V143.361H132.484V136.541C132.484 135.308 132.974 134.125 133.847 133.253C134.719 132.381 135.902 131.891 137.135 131.891Z"
      fill="#E6FFE6"
    />
    <path
      d="M137.787 131.891C137.356 131.891 136.928 131.952 136.514 132.071C137.486 132.348 138.342 132.934 138.951 133.741C139.561 134.547 139.891 135.53 139.891 136.541V143.361H142.438V136.541C142.438 135.308 141.948 134.125 141.076 133.253C140.204 132.381 139.021 131.891 137.787 131.891Z"
      fill="black"
    />
    <path
      d="M137.135 155.899C138.369 155.899 139.552 156.389 140.424 157.262C141.296 158.134 141.786 159.317 141.786 160.55V167.37H132.484V160.55C132.484 159.317 132.974 158.134 133.847 157.262C134.719 156.389 135.902 155.899 137.135 155.899Z"
      fill="#E6FFE6"
    />
    <path
      d="M137.787 155.899C137.356 155.9 136.928 155.961 136.514 156.08C137.486 156.357 138.342 156.943 138.951 157.749C139.561 158.556 139.891 159.539 139.891 160.55V167.37H142.438V160.55C142.438 159.317 141.948 158.134 141.076 157.261C140.204 156.389 139.021 155.899 137.787 155.899Z"
      fill="black"
    />
    <path
      d="M137.135 180.509C138.369 180.509 139.552 180.999 140.424 181.871C141.296 182.743 141.786 183.926 141.786 185.16V191.979H132.484V185.16C132.484 183.926 132.974 182.743 133.847 181.871C134.719 180.999 135.902 180.509 137.135 180.509Z"
      fill="#E6FFE6"
    />
    <path
      d="M137.787 180.509C137.356 180.51 136.928 180.571 136.514 180.69C137.486 180.966 138.342 181.552 138.951 182.359C139.561 183.165 139.891 184.149 139.891 185.16V191.979H142.438V185.16C142.438 183.926 141.948 182.743 141.076 181.871C140.204 180.999 139.021 180.509 137.787 180.509Z"
      fill="black"
    />
    <path
      d="M199.167 169.826C200.32 169.826 201.425 170.284 202.24 171.099C203.055 171.914 203.513 173.02 203.513 174.173V181.297H194.82V174.173C194.82 173.02 195.278 171.914 196.093 171.099C196.908 170.284 198.014 169.826 199.167 169.826Z"
      fill="#E6FFE6"
    />
    <path
      d="M199.776 169.826C199.373 169.827 198.971 169.888 198.586 170.007C199.52 170.318 200.33 170.919 200.898 171.724C201.466 172.528 201.762 173.493 201.742 174.477V181.297H204.123V174.477C204.162 173.284 203.726 172.125 202.911 171.253C202.096 170.381 200.969 169.868 199.776 169.826Z"
      fill="black"
    />
    <path
      d="M248.442 175.562C249.595 175.562 250.701 176.02 251.516 176.835C252.331 177.65 252.789 178.755 252.789 179.908V187.032H244.096V179.908C244.096 178.755 244.554 177.65 245.369 176.835C246.184 176.02 247.289 175.562 248.442 175.562Z"
      fill="#E6FFE6"
    />
    <path
      d="M249.051 175.562C248.648 175.563 248.247 175.624 247.861 175.743C248.796 176.053 249.606 176.655 250.174 177.459C250.742 178.263 251.037 179.228 251.018 180.213V187.032H253.398V180.213C253.437 179.02 253.001 177.86 252.186 176.988C251.372 176.116 250.244 175.603 249.051 175.562Z"
      fill="black"
    />
    <path
      d="M268.153 175.562C269.306 175.562 270.412 176.02 271.227 176.835C272.042 177.65 272.5 178.755 272.5 179.908V187.032H263.807V179.908C263.807 178.755 264.265 177.65 265.08 176.835C265.895 176.02 267 175.562 268.153 175.562Z"
      fill="#E6FFE6"
    />
    <path
      d="M268.762 175.562C268.359 175.563 267.958 175.624 267.572 175.743C268.506 176.053 269.317 176.655 269.885 177.459C270.452 178.263 270.748 179.228 270.729 180.213V187.032H273.109V180.213C273.148 179.02 272.712 177.86 271.897 176.988C271.082 176.116 269.955 175.603 268.762 175.562Z"
      fill="black"
    />
    <path
      d="M253.647 133.851C254.8 133.851 255.906 134.309 256.721 135.124C257.536 135.939 257.994 137.044 257.994 138.197V145.321H249.301V138.197C249.301 137.626 249.413 137.061 249.632 136.534C249.85 136.006 250.17 135.527 250.574 135.124C250.977 134.72 251.457 134.4 251.984 134.181C252.511 133.963 253.077 133.851 253.647 133.851Z"
      fill="#E6FFE6"
    />
    <path
      d="M254.256 133.851C253.853 133.852 253.452 133.913 253.066 134.032C254.001 134.342 254.811 134.944 255.379 135.748C255.947 136.552 256.242 137.517 256.223 138.501V145.321H258.603V138.501C258.642 137.309 258.206 136.149 257.391 135.277C256.577 134.405 255.449 133.892 254.256 133.851Z"
      fill="black"
    />
    <path
      d="M234.499 133.851C235.652 133.851 236.757 134.309 237.572 135.124C238.387 135.939 238.845 137.044 238.845 138.197V145.321H230.152V138.197C230.152 137.626 230.265 137.061 230.483 136.534C230.702 136.006 231.022 135.527 231.425 135.124C231.829 134.72 232.308 134.4 232.836 134.181C233.363 133.963 233.928 133.851 234.499 133.851Z"
      fill="#E6FFE6"
    />
    <path
      d="M235.108 133.851C234.705 133.852 234.304 133.913 233.918 134.032C234.852 134.342 235.662 134.944 236.23 135.748C236.798 136.552 237.094 137.517 237.074 138.501V145.321H239.455V138.501C239.494 137.309 239.058 136.149 238.243 135.277C237.428 134.405 236.301 133.892 235.108 133.851Z"
      fill="black"
    />
    <path
      d="M234.499 115.018C235.652 115.018 236.757 115.476 237.572 116.291C238.387 117.106 238.845 118.211 238.845 119.364V126.488H230.152V119.364C230.152 118.211 230.61 117.106 231.425 116.291C232.241 115.476 233.346 115.018 234.499 115.018Z"
      fill="#E6FFE6"
    />
    <path
      d="M235.108 115.018C234.705 115.019 234.304 115.08 233.918 115.199C234.852 115.509 235.662 116.111 236.23 116.915C236.798 117.719 237.094 118.684 237.074 119.668V126.488H239.455V119.668C239.494 118.476 239.058 117.316 238.243 116.444C237.428 115.572 236.301 115.059 235.108 115.018Z"
      fill="black"
    />
    <path
      d="M253.645 115.018C254.798 115.018 255.904 115.476 256.719 116.291C257.534 117.106 257.992 118.211 257.992 119.364V126.488H249.299V119.364C249.299 118.211 249.757 117.106 250.572 116.291C251.387 115.476 252.493 115.018 253.645 115.018Z"
      fill="#E6FFE6"
    />
    <path
      d="M254.255 115.018C253.851 115.019 253.45 115.08 253.064 115.199C253.999 115.509 254.809 116.111 255.377 116.915C255.945 117.719 256.24 118.684 256.221 119.668V126.488H258.601V119.668C258.64 118.476 258.204 117.316 257.389 116.444C256.575 115.572 255.447 115.059 254.255 115.018Z"
      fill="black"
    />
    <path
      d="M385.426 161.971C384.394 161.971 383.403 162.381 382.673 163.111C381.943 163.841 381.532 164.832 381.532 165.865V172.999H389.32V165.865C389.32 164.832 388.91 163.841 388.18 163.111C387.45 162.381 386.459 161.971 385.426 161.971Z"
      fill="#696969"
    />
    <path
      d="M384.881 161.971C385.243 161.972 385.603 162.031 385.947 162.145C385.087 162.477 384.351 163.07 383.844 163.84C383.337 164.611 383.084 165.521 383.12 166.442V172.999H380.987V166.442C380.987 163.973 382.73 161.971 384.881 161.971Z"
      fill="#E6FFE6"
    />
    <path
      d="M387.509 30.5342C388.542 30.5342 389.532 30.9444 390.263 31.6747C390.993 32.405 391.403 33.3954 391.403 34.4282V41.5625H383.615V34.4282C383.615 33.3954 384.025 32.405 384.756 31.6747C385.486 30.9444 386.476 30.5342 387.509 30.5342Z"
      fill="#E6FFE6"
    />
    <path
      d="M388.054 30.5342C387.692 30.5354 387.332 30.5941 386.988 30.7082C387.849 31.0402 388.584 31.6331 389.091 32.4036C389.598 33.1742 389.852 34.0841 389.816 35.0058V41.5625H391.948V35.0058C391.948 32.5363 390.205 30.5342 388.054 30.5342Z"
      fill="black"
    />
    <path
      d="M364.777 41.5625H356.989V34.4281C356.989 33.3954 357.4 32.4049 358.13 31.6747C358.86 30.9444 359.851 30.5341 360.883 30.5341C361.916 30.5341 362.907 30.9444 363.637 31.6747C364.367 32.4049 364.777 33.3954 364.777 34.4281V41.5625Z"
      fill="#696969"
    />
    <path
      d="M360.337 30.5342C360.7 30.5354 361.06 30.5941 361.404 30.7082C360.543 31.0402 359.808 31.6331 359.301 32.4036C358.794 33.1742 358.54 34.0841 358.576 35.0058V41.5625H356.443V35.0058C356.443 32.5363 358.187 30.5342 360.337 30.5342Z"
      fill="#E6FFE6"
    />
    <path
      d="M416.431 161.971C417.583 161.971 418.689 162.429 419.504 163.244C420.319 164.059 420.777 165.164 420.777 166.317V192.364H412.084V166.317C412.084 165.164 412.542 164.059 413.357 163.244C414.172 162.429 415.278 161.971 416.431 161.971Z"
      fill="#E6FFE6"
    />
    <path
      d="M417.04 161.971C416.636 161.972 416.235 162.033 415.85 162.152C416.784 162.462 417.594 163.064 418.162 163.868C418.73 164.672 419.026 165.637 419.006 166.622V192.364H421.386V166.622C421.425 165.429 420.99 164.269 420.175 163.397C419.36 162.526 418.232 162.012 417.04 161.971Z"
      fill="black"
    />
    <path
      d="M433.403 161.971C434.556 161.971 435.661 162.429 436.477 163.244C437.292 164.059 437.75 165.164 437.75 166.317V192.364H429.057V166.317C429.057 165.164 429.515 164.059 430.33 163.244C431.145 162.429 432.25 161.971 433.403 161.971Z"
      fill="#E6FFE6"
    />
    <path
      d="M434.012 161.971C433.609 161.972 433.208 162.033 432.822 162.152C433.756 162.462 434.567 163.064 435.135 163.868C435.703 164.672 435.998 165.637 435.979 166.622V192.364H438.359V166.622C438.398 165.429 437.962 164.269 437.147 163.397C436.332 162.526 435.205 162.012 434.012 161.971Z"
      fill="black"
    />
    <path
      d="M450.579 161.971C451.732 161.971 452.837 162.429 453.652 163.244C454.468 164.059 454.925 165.164 454.925 166.317V192.364H446.232V166.317C446.232 165.746 446.345 165.181 446.563 164.654C446.782 164.127 447.102 163.647 447.506 163.244C447.909 162.84 448.388 162.52 448.916 162.302C449.443 162.083 450.008 161.971 450.579 161.971Z"
      fill="#E6FFE6"
    />
    <path
      d="M451.188 161.971C450.785 161.972 450.384 162.033 449.998 162.152C450.932 162.462 451.742 163.064 452.31 163.868C452.878 164.672 453.174 165.637 453.154 166.622V192.364H455.535V166.622C455.574 165.429 455.138 164.269 454.323 163.397C453.508 162.526 452.381 162.012 451.188 161.971Z"
      fill="black"
    />
    <path
      d="M467.347 161.971C468.499 161.971 469.605 162.429 470.42 163.244C471.235 164.059 471.693 165.164 471.693 166.317V192.364H463V166.317C463 165.164 463.458 164.059 464.273 163.244C465.088 162.429 466.194 161.971 467.347 161.971Z"
      fill="#E6FFE6"
    />
    <path
      d="M467.956 161.971C467.552 161.972 467.151 162.033 466.766 162.152C467.7 162.462 468.51 163.064 469.078 163.868C469.646 164.672 469.942 165.637 469.922 166.622V192.364H472.302V166.622C472.341 165.429 471.906 164.269 471.091 163.397C470.276 162.526 469.148 162.012 467.956 161.971Z"
      fill="black"
    />
    <path
      d="M204.92 132.875H197.132V118.807C197.132 117.774 197.542 116.784 198.272 116.053C199.003 115.323 199.993 114.913 201.026 114.913C202.059 114.913 203.049 115.323 203.779 116.053C204.51 116.784 204.92 117.774 204.92 118.807V132.875Z"
      fill="#696969"
    />
    <path
      d="M200.48 114.913C200.842 114.914 201.202 114.973 201.546 115.087C200.686 115.419 199.95 116.012 199.443 116.782C198.936 117.553 198.683 118.463 198.718 119.385V132.875H196.586V119.385C196.586 116.915 198.329 114.913 200.48 114.913Z"
      fill="#E6FFE6"
    />
    <path
      d="M201 109.813C203.438 109.813 205.414 107.836 205.414 105.399C205.414 102.961 203.438 100.984 201 100.984C198.562 100.984 196.586 102.961 196.586 105.399C196.586 107.836 198.562 109.813 201 109.813Z"
      fill="#696969"
    />
    <path
      d="M198.192 105.399C198.193 104.368 198.554 103.371 199.214 102.579C199.874 101.787 200.79 101.252 201.803 101.065C201.164 100.941 200.506 100.96 199.875 101.12C199.244 101.28 198.656 101.578 198.153 101.992C197.651 102.407 197.246 102.927 196.969 103.516C196.691 104.105 196.547 104.748 196.547 105.399C196.547 106.05 196.691 106.693 196.969 107.282C197.246 107.871 197.651 108.391 198.153 108.805C198.656 109.219 199.244 109.517 199.875 109.677C200.506 109.837 201.164 109.856 201.803 109.732C200.79 109.545 199.874 109.01 199.214 108.218C198.554 107.427 198.193 106.429 198.192 105.399Z"
      fill="#E6FFE6"
    />
    <path
      d="M268.152 25.7876C270.59 25.7876 272.567 23.8113 272.567 21.3735C272.567 18.9356 270.59 16.9594 268.152 16.9594C265.715 16.9594 263.738 18.9356 263.738 21.3735C263.738 23.8113 265.715 25.7876 268.152 25.7876Z"
      fill="#E6FFE6"
    />
    <path
      d="M270.961 21.3734C270.96 20.343 270.599 19.3453 269.939 18.5538C269.279 17.7622 268.363 17.2267 267.35 17.0402C267.989 16.916 268.647 16.9347 269.278 17.0949C269.91 17.2552 270.497 17.5531 271 17.9672C271.502 18.3813 271.907 18.9015 272.184 19.4904C272.462 20.0793 272.606 20.7223 272.606 21.3734C272.606 22.0245 272.462 22.6675 272.184 23.2564C271.907 23.8453 271.502 24.3655 271 24.7796C270.497 25.1937 269.91 25.4916 269.278 25.6519C268.647 25.8122 267.989 25.8308 267.35 25.7066C268.363 25.5201 269.279 24.9846 269.939 24.193C270.599 23.4015 270.96 22.4039 270.961 21.3734Z"
      fill="black"
    />
    <path
      d="M49.584 192.343H43.1236V183.252C43.1236 182.412 43.4575 181.606 44.0517 181.012C44.6459 180.417 45.4518 180.084 46.2921 180.084H46.4155C47.2559 180.084 48.0618 180.417 48.656 181.012C49.2502 181.606 49.584 182.412 49.584 183.252V192.343Z"
      fill="#696969"
    />
    <path
      d="M47.0772 180.167C46.8485 180.113 46.6146 180.086 46.3798 180.084H46.2564C45.4161 180.084 44.6101 180.418 44.0159 181.012C43.4217 181.606 43.0879 182.412 43.0879 183.252V192.343H44.606V183.252C44.6066 182.534 44.8516 181.837 45.3007 181.276C45.7498 180.716 46.3762 180.324 47.0772 180.167Z"
      fill="#E6FFE6"
    />
    <path
      d="M361.657 81.6301H327.506V192.414H361.657V81.6301Z"
      fill="#696969"
    />
    <path d="M361.657 72.884H327.506V81.6301H361.657V72.884Z" fill="#96FF96" />
    <defs>
      <linearGradient
        id="paint0_linear_9144_6854"
        x1="169.928"
        y1="153.177"
        x2="126.695"
        y2="87.9643"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#02FF02" />
        <stop offset="1" stopColor="#A2FFA1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_9144_6854"
        x1="16.3524"
        y1="190.649"
        x2="-7.02729"
        y2="155.383"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#02FF02" />
        <stop offset="1" stopColor="#A2FFA1" />
      </linearGradient>
    </defs>
  </svg>
);

export default House;
